// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"news-list_wrapper__5HH6b","borderWrap":"news-list_borderWrap___SxuR","grid":"news-list_grid__3WdDT"};